module.exports = __webpack_public_path__ + "img/rating-star-full.c71259e2.svg";